<template>
  <div
    ref="cursor"
    class="timeline-cursor"
    :class="{ [color]: true, 'd-none': hidden }"
    :style="{
      left: `${position * 100}%`,
      'transition-duration': `${motionDuration}s`
    }"
  ></div>
</template>

<script>
// @group Timeline
// Timeline pointer as vertical line
export default {
  name: "TimelineCursor",
  props: {
    // Line color (valid 'pink' or 'yellow')
    color: {
      type: String,
      default: "pink",
      validator: value => ["pink", "yellow"].indexOf(value) !== -1
    }
  },
  /** motion's animation duration */
  smoothMotionDuration: 0.2,
  data() {
    return {
      position: 0,
      motionDuration: 0
    };
  },
  computed: {
    // @vuese
    // Cursor not-visible flag
    hidden() {
      return this.position < 0 || this.position > 1;
    }
  },
  methods: {
    // @vuese
    // Move cursor to new position
    moveTo(position, { smooth = false } = {}) {
      /** is cursor is on position - don't do anything */
      if (position == this.position) {
        return;
      }

      if (smooth) {
        /** move with animation */
        this.motionDuration = this.$options.smoothMotionDuration;
        this.$nextTick(() => {
          this.position = position;
          this.$refs.cursor.addEventListener(
            "transitionend",
            () => {
              this.motionDuration = 0;
            },
            { once: true }
          );
        });
      } else {
        /** move dicretly */
        this.position = position;
      }
    }
  }
};
</script>

<style scoped lang="scss">
//   @import "theme";
$pink: #ff0f88;
$yellow: #fff395;

.timeline-cursor {
  pointer-events: none;
  width: 1px;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: var(--timeline-cursor-z);

  transition-property: left;
  transition-timing-function: ease-in-out;
}

.d-none {
  display: none;
}

.timeline-cursor:before {
  display: block;
  position: absolute;
  z-index: var(--timeline-cursor-z);
  top: -5px;
  left: -4.5px;
  content: "";
  border: 6px solid transparent;
  border-left-width: 5px;
  border-right-width: 5px;
}

.timeline-cursor.pink {
  background-color: $pink;
}

.timeline-cursor.pink:before {
  border-top-color: $pink;
  top: -4px;
}

.timeline-cursor.yellow {
  background-color: $yellow;
}

.timeline-cursor.yellow:before {
  border-top-color: $yellow;
}
</style>
